import { observer } from 'mobx-react';
import React, { Fragment, useState } from 'react';
import { IAdminPageProperties } from '../../../IAdminPageProperties';
import { ActiveDirectoryAdminDomain } from './store/ActiveDirectoryAdminDomain';
import { DataTable } from '../../../../../design/dataTable/DataTable';

export interface ActiveDirectoryAdminTableProperties extends IAdminPageProperties {}

export const ActiveDirectoryAdminTable = observer(({ layoutDomain }: ActiveDirectoryAdminTableProperties) => {
  const [domain] = useState(new ActiveDirectoryAdminDomain(layoutDomain));

  return (
    <Fragment>
      <DataTable dataTableDomain={domain}/>
    </Fragment>
  );
});
